import { render, staticRenderFns } from "./DynamicSelect.vue?vue&type=template&id=55ff5d57&scoped=true&"
import script from "./DynamicSelect.vue?vue&type=script&lang=js&"
export * from "./DynamicSelect.vue?vue&type=script&lang=js&"
import style0 from "./DynamicSelect.vue?vue&type=style&index=0&id=55ff5d57&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ff5d57",
  null
  
)

export default component.exports